// extracted by mini-css-extract-plugin
export default {"card":"card_card__k6nAe","title":"card_title__m7snr","content":"card_content__RZhSF","footnote":"card_footnote__mOpJc"};